import { useQuery } from '@tanstack/vue-query';

import { fetchEmailTempaltes } from '@/api/email-template.api';

export const useEmailTemplates = () => {
    return useQuery(['email-templates'], async () => fetchEmailTempaltes(), {
        initialData: [],
    });
};
